export const main = (filters) => [
  {text: '', value: 'actions', width: 100},
  // { text: 'ID', align: 'start', value: 'id', width: '5rem',  
  //     filter: value => {
  //                 if ( !filters.find(x=>x.name === 'id')?.value) return true
  //                 return value == filters.find(x=>x.name === 'id')?.value
  //     }
  // },
  // { text: 'Tháng khởi tạo', align: 'start', value: 'employeeReadyReviewMonth', width: '7rem',
  //     filter: value => true
  // },
  
  { text: 'Mã NS', align: 'start', value: 'keyEmployeeCode', width: '7rem',  
      filter: value => {
        if ( !filters.find(x=>x.name === 'keyEmployeeCode')?.value) return true
        return value.includes(filters.find(x=>x.name === 'keyEmployeeCode')?.value)
      }
  },
  { text: 'Tên NS', align: 'start', value: 'keyEmployeeName', width: '10rem',  
      filter: value => {
        if ( !filters.find(x=>x.name === 'keyEmployeeName')?.value) return true
        return value.includes(filters.find(x=>x.name === 'keyEmployeeName')?.value)
      }
  },
  { text: 'Ngày nhận việc', align: 'start', value: 'keyEmployeeHireDate', width: '7rem',
      filter: value => true
  },
  
  { text: 'Thâm niên (Tháng)', align: 'start', value: 'keySenMonth', width: '7rem',
      filter: value => true
  },
  
  { text: 'Người phê duyệt', align: 'start', value: 'keyFinalManagerName', width: '7rem',
      filter: value => true
  },
  
  { text: 'Người phê duyệt(tạm thời)', align: 'start', value: 'keyApprovedByName', width: '7rem',
      filter: value => true
  },

  { text: 'Chức danh', align: 'start', value: 'keyEmployeePositionStateCode', width: '7rem',
      filter: value => true
  },
  
  { text: 'Điểm nhóm NVM', align: 'start', value: 'totalScoreNvm', width: '10rem',
      filter: value => true
  },
  // { text: 'NVM', align: 'start', value: 'totalMaxScoreNvm',
  //     filter: value => true
  // },
  // { text: 'COT2', align: 'start', value: 'totalMaxScoreCot2',
  //     filter: value => true
  // },
  { text: 'Điểm nhóm COT2', align: 'start', value: 'totalScoreCot2', width: '10rem',
      filter: value => true
  },
  




  
//   { text: 'Nhận việc', align: 'start', value: 'employeeHireDate',
//       filter: value => true
//   },
  
//   { text: 'Thâm niên (Tháng)', align: 'start', value: 'senMonth',
//       filter: value => true
//   },

//   { text: 'Loại phiếu', align: 'start', value: 'type',
//       filter: value => true
//   },
  
//   { text: 'Tháng review', align: 'start', value: 'monthNo',
//       filter: value => true
//   },
  
//   { text: 'Người xác nhận', align: 'start', value: 'approvedByCode',
//       filter: value => true
//   },

//   // { text: 'Đến', align: 'start', value: 'validTo',
//   //     filter: value => true
//   // },

//   { text: 'Điểm', align: 'start', value: 'score',
//       filter: value => true
//   },
  
//   { text: 'Tổng điểm', align: 'start', value: 'maxScore',
//       filter: value => true
//   },
//   { text: 'Trạng thái', align: 'start', value: 'status', width: '8rem',
//       filter: value => {
//         if ( !filters.find(x=>x.name === 'status')?.value) return true
//         return value.includes(filters.find(x=>x.name === 'status')?.value)
//       }
//   },

//   { text: 'Tạo', align: 'start', value: 'createdBy',
//       filter: value => true
//   },
//   { text: 'Tạo vào', align: 'start', value: 'createdAt',
//       filter: value => true
//   },

]

export const view = (filters) => [
//   {text: '', value: 'actions', width: 100},
  { text: 'ID', align: 'start', value: 'id', width: '5rem',  
      filter: value => {
                  if ( !filters.find(x=>x.name === 'id')?.value) return true
                  return value == filters.find(x=>x.name === 'id')?.value
      }
  },
  
  { text: 'Nhóm', align: 'start', value: 'conditionGroup', width: '10rem',},
  { text: 'Điều kiện', align: 'start', value: 'conditionTitle' },
  
  { text: 'Đánh giá', align: 'start', value: 'score' }
]

export const finalHeaders = [
  // {text: '', value: 'actions', width: 100},
  { text: 'Tháng', align: 'start', value: 'month', width: '7rem' },
  // { text: 'Tổng phiếu', align: 'start', value: 'count' },
  { text: 'Số nhân sự', align: 'start', value: 'employeeCount' },
  { text: 'Số NVM', align: 'start', value: 'final.totalReviewNvm' },
  { text: 'Số NVM đạt', align: 'start', value: 'final.completeNvm' },
  { text: 'Số COT2', align: 'start', value: 'final.totalReviewCot2' },
  { text: 'Số COT2 đạt', align: 'start', value: 'final.completeCot2' },
  // { text: 'Trạng thái', align: 'start', value: 'status' },
  { text: 'Chốt kỳ', align: 'start', value: 'setFinal' },
  { text: 'Reset', align: 'start', value: 'resetFinal' },
  // { text: 'Chưa hoàn tất NVM', align: 'start', value: 'incompleteNvm' },
  // { text: 'Hoàn tất NVM', align: 'start', value: 'completeNvm' },
  // { text: 'Tổng phiếu NVM', align: 'start', value: 'totalReviewNvm' },
  // { text: 'Chưa hoàn tất COT2', align: 'start', value: 'incompleteCot2' },
  // { text: 'Hoàn tất COT2', align: 'start', value: 'completeCot2' },
  // { text: 'Tổng phiếu COT2', align: 'start', value: 'totalReviewCot2' },
]

export const readyHeaders = [
  { text: 'Mã nhân viên', align: 'start', value: 'employeeCode' },
  { text: 'Tên nhân viên', align: 'start', value: 'employeeName' },
  { text: 'Ngày nhận việc', align: 'start', value: 'hireDate' },
  { text: 'Phân loại', align: 'start', value: 'type' },
  { text: 'Mã NS đánh giá', align: 'start', value: 'finalManagerCode' },
  { text: 'Người đánh giá', align: 'start', value: 'finalManagerName' },
  { text: 'Chỉ định người đ/giá (tạm thời)', align: 'start', value: 'smCode' },
]